import styled from "styled-components";

export const UserContent = styled.div`
  min-width: 700px;
  margin-right: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
